<template>
  <b-col cols="6">
    <div class="form-label">
      <label>{{ $t(actionTitle) }}</label>
    </div>
    <div class="logo-box d-flex align-items-center justify-content-center">
      <img
        class="img-fluid"
        :src="logo"
        :alt="$t(actionTitle)"
        aria-hidden="true"
      >
    </div>
    <div class="mt-2 text-center">
      <b-form-group>
        <div>
          <label
            v-if="!selectedLogo"
            class="mr-3"
          ><i
            class="far fa-upload mr-2"
            aria-hidden="true"
          />{{ $t('component.studyRequest.addFileModal.labelFile') }}</label>
          <label
            v-if="selectedLogo"
            class="mr-3"
          ><i
            class="far fa-check green-radiant mr-2"
            aria-hidden="true"
          />{{ $t('configuration.modal.user.pictureSelected') }}</label>
        </div>
        <b-button
          :id="`${id}`"
          class="btn__outline"
          size="sm"
        >
          {{ $t('configuration.modal.user.browseTextButton') }}
        </b-button>
        <b-button
          v-if="selectedLogo"
          class="btn__outline ml-1"
          size="sm"
          @click="deleteImg"
        >
          <i
            class="far fa-trash-alt mr-2"
            aria-hidden="true"
          />{{ $t('global.delete') }}
        </b-button>
        <avatar-cropper
          :upload-handler="cropperHandler"
          :cropper-options="cropperOptions"
          :labels="{ submit: $t('global.accept'), cancel: $t('global.cancel')}"
          :trigger="`#${id}`"
        />
      </b-form-group>
    </div>
  </b-col>
</template>

<script>
import defaultLogo from '@/img/logo-placeholder.jpg'
import AvatarCropper from 'vue-avatar-cropper'

export default {
    name: 'LaboratoryConfigurationImageUploader',
    components: { AvatarCropper },
    props: {
        id: { type: String, required: false },
        actionTitle: { type: String, required: false },
        getLogo: { type: Function, required: false },
        setLogo: { type: Function, required: false },
        deleteLogo: { type: Function, required: false },
        updateLogo: { type: Boolean, default: false },
        messageUpload: { type: String, required: false },
        messageDelete: { type: String, required: false }
    },
    data() {
        return {
            selectedLogo: false,
            logo: defaultLogo,
            cropperOptions: {
                aspectRatio: 3
            },
            replaceBlob: null
        }
    },
    mounted() {
        this.renderImg()
    },
    methods: {
        async renderImg() {
            const logo = await this.getLogo()
            if (logo) {
                this.selectedLogo = true
                this.logo = window.URL.createObjectURL(logo)
            } else {
                this.selectedLogo = false
                this.logo = defaultLogo
            }
        },
        cropperHandler(cropper) {
            this.logo = cropper.getCroppedCanvas({ width: 300, height: 100 }).toDataURL()
            cropper.getCroppedCanvas({ width: 300, height: 100 }).toBlob(async blob => {
                this.replaceBlob = await blob
                await this.setLogo(this.replaceBlob)
                if (this.updateLogo) {
                    // Emit event for the Navbar Component to update logo of laboratory
                    this.$root.$emit('change:laboratory:configuration:logo', this.replaceBlob)
                }
                this.selectedLogo = true
                this.showToastSuccessGlobal(this.messageUpload)
            })
        },
        async deleteImg() {
            await this.deleteLogo()
            this.replaceBlob = null
            this.selectedLogo = false
            this.logo = defaultLogo
            this.showToastSuccessGlobal(this.messageDelete)
            if (this.updateLogo) {
                this.$root.$emit('change:laboratory:configuration:logo', null)
            }
        }
    }
}

</script>

<style scoped lang="scss">

</style>
